<template>
  <div
    v-if="value"
    class="bbp-image-cell"
    :class="{'bbp-image-cell_disabled': row.disabled}"
    @click="clickToImg"
    @mouseenter="setDisplayPopup($event, true)"
    @mouseleave="setDisplayPopup($event, false)"
  >
    <img :src="image" v-if="image" class="bbp-image-cell__image"/>
    <i :class="'bbp-icon-' + defaultIcon" v-else-if="defaultIcon" class="bbp-image-cell__image"/>
    <transition name="bbp-bounce">
      <div class="bbp-image-cell-popup" v-if="popup && hoverImage" :style="popupPosition">{{popup}}</div>
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'

export default {
  name: 'BBPImageCell',
  props: ['row', 'column', 'index'],
  data () {
    return {
      hoverImage: false,
      popupPosition: {}
    }
  },
  computed: {
    image () {
      return get(this.row, this.column.display, '')
    },
    value () {
      return get(this.row, this.column.prop, '')
    },
    defaultIcon () {
      return get(this.column, 'defaultIcon', '')
    },
    popup () {
      return get(this.row, this.column.popup, '')
    }
  },
  methods: {
    clickToImg () {
      const { _id } = this.value
      this.$emit('filter', {row: this.row, column: this.column, newVal: _id})
    },
    setDisplayPopup (e, val) {
      this.hoverImage = val
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.popupPosition = {
          position: 'fixed',
          top: position.top + position.height + 4 + 'px',
          left: 'auto'
        }
      } else {
        this.popupPosition = {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-image-cell {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    cursor: pointer;

    &_disabled {
      opacity: 0.5;
    }

   &__image {
     width: 100%;
     height: 100%;
     color: $color-accent;
     object-fit: cover;
     font-size: 28px;
     border-radius: 50%;

     &:before {
       margin: 0;
     }
   }

    &-popup {
      position: absolute;
      left: auto;
      top: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      padding: 4px 7px;
      background: rgba($color-black, 0.55);
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      text-align: center;
      color: $color-white;
      border-radius: 3px;
      z-index: 20;
      pointer-events: none;
      text-transform: capitalize;

      &:before {
        content: '';
        position: absolute;
        left: auto;
        top: -3px;
        display: block;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-bottom: 3px solid rgba($color-black, 0.55);;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPImageCell/BBPImageCell.vue